import { useSelector } from 'react-redux';
import { PAYMENT_GATEWAY, STRIPE_ACCOUNT_FALLBACK } from '../constants';
import { selectStripe } from '../store/signup';

export const useStripeAccount = () => {
  const { key: stripePk, name: stripeAccountName } = useSelector(selectStripe);
  const stripeGateway = PAYMENT_GATEWAY.stripe(stripeAccountName, STRIPE_ACCOUNT_FALLBACK.CARD);

  return { stripePk, stripeAccountName, stripeGateway };
};
